import i18n from "@/i18n";

export default [
  {
    path: "/home",
    alias: "/enroll", // 兼容旧路由
    name: "Home",
    component: () => import("@/pages/home/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].home.home,
      requireAuth: true,
      breadcrumb: [{ title: "home.home" }],
    },
  },
  {
    path: "/enroll/creation",
    name: "EnrollCreation",
    component: () => import("@/pages/creation/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].creation.creation,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "creation.creation" }],
    },
  },
  {
    path: "/enroll/notPaid",
    name: "EnrollNotPaid",
    component: () => import("@/pages/notPaid/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].notPaid.notPaid,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "notPaid.notPaid" }],
    },
  },
  {
    path: "/enroll/payment",
    name: "EnrollPayment",
    component: () => import("@/pages/payment/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].payment.payment,
      requireAuth: true,
      breadcrumb: [
        { title: "home.home", name: "Home" },
        { title: "notPaid.notPaid", name: "EnrollNotPaid", queryKeys: ["applymentId", "adjustmentId"] },
        { title: "payment.payment" },
      ],
    },
  },
  {
    path: "/enroll/intitle",
    name: "EnrollIntitle",
    component: () => import("@/pages/enroll/intitle/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].enroll.intitle.intitle,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "enroll.intitle.intitle" }],
    },
  },
  {
    path: "/enroll/questionnaire",
    name: "EnrollQuestionnaire",
    component: () => import("@/pages/enroll/questionnaire/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].enroll.questionnaire.questionnaire,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "enroll.questionnaire.questionnaire" }],
    },
  },
  {
    path: "/enroll/establish",
    name: "EnrollEstablish",
    component: () => import("@/pages/enroll/establish/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].enroll.establish.establish,
      requireAuth: true,
      breadcrumb: [
        { title: "home.home", name: "Home" },
        {
          title: "enroll.establish.establish",
          titleByCountry: {
            Malaysia: "enroll.establish.malaysia.businessInformation",
          },
        },
      ],
    },
  },
  {
    path: "/enroll/upload",
    name: "EnrollUpload",
    component: () => import("@/pages/enroll/upload/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].enroll.upload.upload,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "enroll.upload.upload" }],
    },
  },
  {
    path: "/enroll/quotation",
    name: "EnrollQuotation",
    component: () => import("@/pages/enroll/quotation/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].enroll.quotation.quotation,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "enroll.quotation.quotation" }],
    },
  },
  {
    path: "/enroll/affirm",
    name: "EnrollAffirm",
    component: () => import("@/pages/enroll/affirm/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].enroll.affirm.affirm,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "enroll.affirm.affirm" }],
    },
  },
  {
    path: "/enroll/details",
    name: "EnrollDetails",
    component: () => import("@/pages/enroll/details/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].enroll.details.details,
      requireAuth: true,
      breadcrumb: [{ title: "home.home", name: "Home" }, { title: "enroll.details.details" }],
    },
  },
];
